export const getDomain = (market) => {
    if (market !== 'en') {
        return market;
    }

    return 'io';
};
